<p-dialog
  [(visible)]="popupVisibleDetail"
  [modal]="true"
  class="popupDetail"
  [header]="'Details des logs de ' + popupCurrentId"
  [style]="{ width: '100vw', height: '100vh' }"
>
  <div class="content flex justify-content-center">
    <div>
      @for (l of popupCurrentLog; track l.date) {
        <div>{{ l.date | date: "short" }} - {{ l.message }}</div>
      }
    </div>
  </div>

  <div class="ui-dialog-footer text-center mt-4 flex justify-content-around">
    <p-button (click)="popupVisibleDetail = false">OK</p-button>
  </div>
</p-dialog>

<div class="ml-3">
  <i [routerLink]="'/admin'" class="cursor-pointer absolute pi pi-arrow-left ml-auto" style="left: 0; top: 10px"></i>
</div>

<h1 class="mb-0">{{ filteredLogs.length }} utilisateurs</h1>
<button
  pButton
  class="absolute"
  style="right: 10px; top: 10px"
  [label]="'Export CSV (' + filteredLogs.length + ' users)'"
  (click)="exportCSV()"
></button>

<h2>Dates</h2>
<p-selectButton
  [options]="datesOptions"
  [(ngModel)]="selectedDates"
  [multiple]="true"
  (ngModelChange)="filtering()"
  optionLabel="name"
  optionValue="value"
>
  <ng-template let-item pTemplate>
    {{ item.name }} <span class="text-green-400 ml-1 font-bold">{{ item.stats }}</span>
  </ng-template>
</p-selectButton>

<h2>Programmes</h2>
<p-selectButton
  [options]="programsOptions"
  [(ngModel)]="selectedPrograms"
  [multiple]="true"
  (ngModelChange)="filtering()"
  optionLabel="name"
  optionValue="value"
>
  <ng-template let-item pTemplate>
    {{ item.name }} <span class="text-green-400 ml-1 font-bold">{{ item.stats }}</span>
  </ng-template>
</p-selectButton>

@if (selectedPrograms.length === 1) {
  <p-listbox
    [options]="filteredLogs"
    optionLabel="name"
    [listStyle]="{ 'max-height': 'calc(100vh - 400px)' }"
    [style]="{ width: '100vw' }"
  >
    <ng-template let-log pTemplate="item">
      <div (click)="open(log.id)">
        {{ log["logs-" + selectedPrograms[0]]?.length }} page(s) vue(s)
        <span class="font-italic text-xs ml-1"
          >{{ log.dates.length }} date(s): [
          @for (d of log.dates; track d) {
            {{ d }}&nbsp;
          }
          ]</span
        >
        - {{ log.id }}
      </div>
    </ng-template>
  </p-listbox>
} @else {
  <div class="text-xl p-3 text-red font-bold">
    La liste détaillée ne s'affiche que lorsqu'un seul programme est sélectionné.
  </div>
}
